import React from 'react';

import RelatedSearchItem from '../../app/Search/components/relatedSearch/RelatedSearchItem';
import {
  linkWithOrigin,
  SearchOrigin,
} from '../../app/Search/utils/browseLinkUtils';
import { DetailsKeywords } from '../../common/types/StockItemTypes';
import { Stack, StackAlignment, StackDirection } from '../../storywind';

import './stock-item-seo-links.less';

type Props = {
  title?: string;
  keywords: DetailsKeywords[];
};

export default function StockItemKeyWordLinks({ title, keywords }: Props) {
  const itemTitle = title || 'Keywords';

  return (
    <div id={itemTitle} className="stockItemSeoLinks">
      <h3 className="stockItemSeoLinks-subHeader">{itemTitle}</h3>
      <p className="stockItemSeoLinks-links">
        {keywords.map(({ keyword, url }) => {
          return (
            <span
              className="stockItemSeoLinks-link"
              data-selenium-value={keyword}
              key={keyword}
            >
              <a href={url} onClick={(e) => linkWithOrigin(e, url)}>
                {keyword}
              </a>
            </span>
          );
        })}
      </p>
    </div>
  );
}

export const PilledStockItemKeywordLinks = ({ title, keywords }: Props) => {
  const itemTitle = title || 'Keywords';

  return (
    <div id={itemTitle} className="stockItemSeoLinks" role="group">
      <h3 className="stockItemSeoLinks-subHeader">{itemTitle}</h3>
      <Stack
        yGap={0}
        xGap={1}
        alignment={StackAlignment.Left}
        direction={StackDirection.Row}
      >
        {keywords.map(({ keyword, url }) => (
          <RelatedSearchItem
            key={url}
            keyword={keyword}
            url={url}
            onSearchTermClicked={(e) =>
              linkWithOrigin(e, url, SearchOrigin.RELATED_SEARCH)
            }
            roundedDesign
            showIcon={false}
          />
        ))}
      </Stack>
    </div>
  );
};
